/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import {
  Modal,
  Button,
  Box,
  CircularProgress,
  TextField,
  Card,
  CardContent,
  CardActions,
  CardHeader,
  IconButton,
  InputAdornment,
  MenuItem
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { ValidateUOM } from '../../assets/validation';
import ContentLoader from '../../utils/errorPages/ContentLoader';
import globalAction from '../../store/actions/GlobalAction';
import UomAction from '../../store/actions/UomAction';

function UOMEdit({ itemId, openmodal, onCloseModal }) {
  /* Modal Style */

  const dispatch = useDispatch();

  // Replace 'data' with your reducer name
  const { uomItemData, isLoading } = useSelector((state) => state.uom);
  const { statusData } = useSelector((state) => state.global);

  useEffect(() => {
    dispatch(UomAction.getItem(itemId));
    dispatch(globalAction.getClientStatus());
  }, [dispatch, itemId]);

  // useEffect(() => {
  //   if (listData) {
  //     if (listData.data) {
  //       setData(listData.data);
  //     } else {
  //       setData([]);
  //     }
  //     setRowCountState((prevRowCountState) =>
  //       listData.total !== undefined ? listData.total : prevRowCountState
  //     );
  //   }
  // }, [listData]);

  const getDirtyValues = (values, initialObject) => {
    const data = { ...values };
    const keyValues = Object.keys(data);

    const dirtyValues = keyValues.filter((keyValue) => data[keyValue] !== initialObject[keyValue]);

    keyValues.forEach((key) => {
      if (!dirtyValues.includes(key)) delete data[key];
    });
    return data;
  };

  const initialValues = {
    name: uomItemData && uomItemData.name ? uomItemData.name : '',
    status: uomItemData && uomItemData.status ? uomItemData.status : '',
    short_name: uomItemData && uomItemData.short_name ? uomItemData.short_name : ''
  };

  return (
    <Modal
      className="cmn__form__modal"
      open={openmodal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box>
        {isLoading ? <ContentLoader /> : ''}
        <Formik
          initialValues={initialValues}
          enableReinitialize
          validationSchema={ValidateUOM}
          onSubmit={(values, { setErrors, setSubmitting }) => {
            const updateValues = getDirtyValues(values, initialValues);
            dispatch(
              UomAction.update(itemId, updateValues, setErrors, setSubmitting, onCloseModal)
            );
          }}
        >
          {({
            errors,
            touched,
            values,
            handleChange,
            handleBlur,
            handleSubmit,
            handleReset,
            isSubmitting,
            setFieldValue
          }) => (
            <form onSubmit={handleSubmit}>
              <Card>
                <CardHeader
                  title="Edit UOM"
                  action={
                    <IconButton
                      aria-label="settings"
                      onClick={() => {
                        onCloseModal();
                      }}
                    >
                      <Close />
                    </IconButton>
                  }
                />
                <CardContent>
                  <TextField
                    id="name"
                    fullWidth
                    label="UOM Name"
                    name="name"
                    margin="normal"
                    placeholder="Enter UOM Name"
                    value={values.name}
                    onChange={handleChange}
                    onBlur={(e) => {
                      const val = (e.target.value || '').replace(/\s+/gi, ' ');
                      setFieldValue(e.target.name, val.trim());
                      handleBlur(e);
                    }}
                    error={errors.name && touched.name}
                    helperText={errors.name && touched.name && errors.name}
                    required={false}
                    InputLabelProps={{ required: true }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start">
                          <IconButton
                            aria-label="toggle password visibility"
                            edge="end"
                            disabled
                            sx={{
                              bgcolor: 'secondary.main',
                              borderRadius: '5px',
                              '&.Mui-disabled': {
                                bgcolor: 'secondary.main'
                              },
                              '&:hover': {
                                borderColor: 'secondary.main',
                                borderWidth: '1px',
                                borderStyle: 'solid'
                              }
                            }}
                            // color="secondary"
                          >
                            <i className="icon-measure" />
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                  />
                  <TextField
                    id="short_name"
                    fullWidth
                    label="UOM Short Name"
                    name="short_name"
                    margin="normal"
                    placeholder="Enter UOM Short Name"
                    value={values.short_name}
                    onChange={handleChange}
                    onBlur={(e) => {
                      const val = (e.target.value || '').replace(/\s+/gi, '');
                      setFieldValue(e.target.name, val.trim());
                      handleBlur(e);
                    }}
                    error={errors.short_name && touched.short_name}
                    helperText={errors.short_name && touched.short_name && errors.short_name}
                    required={false}
                    InputLabelProps={{ required: true }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start">
                          <IconButton
                            aria-label="toggle password visibility"
                            edge="end"
                            disabled
                            sx={{
                              bgcolor: 'secondary.main',
                              borderRadius: '5px',
                              '&.Mui-disabled': {
                                bgcolor: 'secondary.main'
                              },
                              '&:hover': {
                                borderColor: 'secondary.main',
                                borderWidth: '1px',
                                borderStyle: 'solid'
                              }
                            }}
                            // color="secondary"
                          >
                            <i className="icon-measure" />
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                  />
                  <TextField
                    id="status"
                    fullWidth
                    label="Status"
                    name="status"
                    margin="normal"
                    select
                    value={values.status}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={errors.status && touched.status}
                    helperText={errors.status && touched.status && errors.status}
                    required={false}
                    InputLabelProps={{ required: true }}
                  >
                    {statusData &&
                      statusData.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                          {option.status}
                        </MenuItem>
                      ))}
                  </TextField>
                </CardContent>
                <CardActions sx={{ justifyContent: 'center' }}>
                  <Button
                    type="submit"
                    className="save__btn"
                    variant="contained"
                    color="secondary"
                    disabled={isSubmitting}
                    size="medium"
                  >
                    {isSubmitting ? <CircularProgress size={20} /> : 'Submit'}
                  </Button>
                  <Button
                    type="button"
                    className="cancel__btn"
                    variant="contained"
                    color="info"
                    size="medium"
                    onClick={() => {
                      handleReset();
                    }}
                  >
                    Clear
                  </Button>
                </CardActions>
              </Card>
            </form>
          )}
        </Formik>
      </Box>
    </Modal>
  );
}
UOMEdit.propTypes = {
  itemId: PropTypes.string.isRequired,
  openmodal: PropTypes.string.isRequired,
  onCloseModal: PropTypes.func.isRequired
};

export default UOMEdit;
